/**
 * Iter327 · Bug 9 — Global safe navigation helper.
 * Iter328 fix — Simplified to pure hard navigation. The previous
 * `history.replaceState + dispatchEvent(popstate)` implementation
 * caused a redirect loop when React Router re-ran ProtectedRoute
 * on the synthesized popstate before AuthContext had propagated the
 * new user state, and Firefox subsequently re-hit the "insecure"
 * path on retry. A hard `location.replace` is guaranteed to be a
 * single, terminal navigation — no popstate loop, no double redirect
 * — and it's what Firefox/Safari actually allow (only
 * `history.replaceState` throws "operation is insecure", not
 * `location.replace`).
 */
export function safeReplace(pathOrHref) {
  if (!pathOrHref) return false;
  try {
    window.location.replace(pathOrHref);
    return true;
  } catch (_e1) {
    try { window.location.assign(pathOrHref); return true; }
    catch (_e2) { return false; }
  }
}

/** Push-navigate variant. Hard-nav to avoid popstate loops. */
export function safeAssign(pathOrHref) {
  if (!pathOrHref) return false;
  try { window.location.assign(pathOrHref); return true; }
  catch (_e) { return false; }
}
